var BlockPresentation = {
	init:function(){
		var pictures = gsap.utils.toArray(".pictures img");
		pictures.forEach((picture, index) =>{
			var position = 0;
			var rotation = 0;
			if(index == 1){
				rotation = 0;
				position = 100;
			}
			if(index == 2){
				rotation = 0;
				position = 200;
			}
			gsap.from(
				picture,
				{
					scrollTrigger: {
						trigger: picture,
						start: "top-=100% bottom",
						//end: '+='+parseInt((document.querySelector('.info').offsetHeight*3)+300),
						scrub:true
					},
					rotate:rotation,
					yPercent:position
				}
			);
		});
	},
};

$(window).load(function(){
	if($(".block-presentation").length && window.innerWidth > 990){
		BlockPresentation.init();
	}
});
